import React, { useEffect, useId, useRef, useState } from 'react';

export default function LogoutConfirmation({ onCancel, onConfirm, returnFocusRef }) {
  const titleId = useId();
  const descriptionId = useId();
  const cancelRef = useRef(null);
  const pendingRef = useRef(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const opener = returnFocusRef?.current || document.activeElement;
    cancelRef.current?.focus();
    return () => { if (opener?.isConnected) opener.focus(); };
  }, [returnFocusRef]);

  const confirm = async () => {
    if (pendingRef.current) return;
    pendingRef.current = true;
    setIsLoggingOut(true);
    setError('');
    try {
      const result = await onConfirm();
      if (result === false) setError('Couldn’t log out. Please try again.');
      else onCancel();
    } catch {
      setError('Couldn’t log out. Please try again.');
    } finally {
      pendingRef.current = false;
      setIsLoggingOut(false);
    }
  };

  return (
    <div className="settings-confirmation-backdrop"
      onMouseDown={event => {
        if (event.target === event.currentTarget && !isLoggingOut) onCancel();
      }}>
      <section className="settings-confirmation" role="alertdialog" aria-modal="true"
        aria-labelledby={titleId} aria-describedby={descriptionId} tabIndex={-1}
        onKeyDown={event => {
          if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            if (!isLoggingOut) onCancel();
          }
        }}>
        <h2 id={titleId}>Log out of Arrow?</h2>
        <p id={descriptionId}>You can sign back in to access your chats and memories.</p>
        {error && <p role="alert" className="settings-confirmation-error">{error}</p>}
        <div className="settings-actions">
          <button ref={cancelRef} type="button" className="settings-button"
            onClick={onCancel} disabled={isLoggingOut}>Cancel</button>
          <button type="button" className="settings-button settings-primary"
            onClick={confirm} disabled={isLoggingOut}>
            {isLoggingOut ? 'Logging out…' : 'Log out'}
          </button>
        </div>
      </section>
    </div>
  );
}
